import {
  AccessFragment,
  OtpFragment,
  ProfileFragment,
  RefreshAccessFragment,
} from "../../models/autogenerated-deliveryService-gql/graphql";
import { User } from "../../models/user";

export enum UserActionTypes {
  SetOtpResponse = "SET_OTP_RESPONSE",
  Login = "LOGIN",
  RefreshAccess = "REFRESH_ACCESS",
  Logout = "LOGOUT",
  SetProfile = "SET_PROFILE",
}

interface IUserActionSetOtpResponse {
  type: UserActionTypes.SetOtpResponse;
  value: OtpFragment;
}
interface IUserActionLogin {
  type: UserActionTypes.Login;
  value: AccessFragment;
}

interface IUserActionRefreshAccess {
  type: UserActionTypes.RefreshAccess;
  value: RefreshAccessFragment;
}

interface IUserActionSetProfile {
  type: UserActionTypes.SetProfile;
  value: ProfileFragment;
}

interface IUserActionLogout {
  type: UserActionTypes.Logout;
}

export const nullUser: User = {
  otpResponse: null,
  accessToken: null,
  refreshToken: null,
  role: null,
  permissions: [],
  profile: null,
};

export type IUserAction =
  | IUserActionSetOtpResponse
  | IUserActionLogin
  | IUserActionRefreshAccess
  | IUserActionLogout
  | IUserActionSetProfile;

const updateLocalStorageTokens = (
  accessToken: string,
  refreshToken: string,
) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
};

const clearLocalStorageTokens = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  window.dispatchEvent(new Event("logOut"));
};

export const userReducer = (state: User, action: IUserAction): User => {
  switch (action.type) {
    case UserActionTypes.SetOtpResponse:
      return { ...state, otpResponse: action.value };
    case UserActionTypes.SetProfile:
      return { ...state, profile: action.value };
    case UserActionTypes.Login:
      updateLocalStorageTokens(
        action.value.accessToken,
        action.value.refreshToken,
      );
      return {
        otpResponse: state.otpResponse,
        profile: state.profile,
        ...action.value,
      };
    case UserActionTypes.RefreshAccess:
      updateLocalStorageTokens(
        action.value.accessToken,
        action.value.refreshToken,
      );
      return {
        otpResponse: state.otpResponse,
        profile: state.profile,
        ...action.value,
      };
    case UserActionTypes.Logout:
      clearLocalStorageTokens();
      return nullUser;
    default:
      return state;
  }
};
